import { BaseEventBuilder } from '@droidmap/shared-service-contract'

import { Grant } from '../models/grant.js'

const serviceSource = 'droidmap.backend.permissions-service'

export const GrantCreated = new BaseEventBuilder<Grant, 'Grant Created'>(
  serviceSource,
  'Grant Created',
)

export const GrantDeleted = new BaseEventBuilder<Grant, 'Grant Deleted'>(
  serviceSource,
  'Grant Deleted',
)
